/* import __COLOCATED_TEMPLATE__ from './checkable-btn.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

interface BvResourceListCheckableBtnSignature {
  Args: {
    accessibilityLabel?: string;
    disabled?: boolean;
    label?: string;
    measuring?: boolean;
    onToggleAll?: () => void;
    plain?: boolean;
    selectMode?: boolean;
    selected?: boolean;
  };
  Element: HTMLDivElement;
}

const BvResourceListCheckableBtnComponent =
  templateOnlyComponent<BvResourceListCheckableBtnSignature>();

export default BvResourceListCheckableBtnComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvResourceList::CheckableBtn': typeof BvResourceListCheckableBtnComponent;
    'bv-resource-list/checkable-btn': typeof BvResourceListCheckableBtnComponent;
  }
}
